// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-with-select[data-v-774615f4] {\n  width: 200px;\n}\n.el-form-item__content[data-v-774615f4] {\n  line-height: 20px;\n}\n.el-checkbox[data-v-774615f4] {\n  width: 100%;\n  margin-right: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
